import {connect, useSelector} from "react-redux";
import React, {useRef, useState} from "react";
import {getCkProductBrandMappingList,
        updateProductBrandMapping,
        getCkProductBrandMultiMappingList,
        deleteProductBrandMapping} from "../../../../api/api";
import {
    CButton,
    CCol,
    CForm, CFormInput,
    CInputGroup,
    CInputGroupText, CRow,
} from "@coreui/react";
import {Loading} from "../../../../components/common";
import {AgGridReact} from "ag-grid-react";
import StoreCornerListWhere from "../../where/StoreCornerListWhere";
import * as saleMethod from "../../../../api/method/saleMethod";

const ProductBrandMultiMapping = (props) => {
    const { user } = useSelector((props) => props.account);
    const gridRef = useRef();
    const detailGridRef = useRef();
    const [activeKey, setActiveKey] = useState(1);
    const [rowData, setRowData] = useState([]);
    const [brandMappingData, setBrandMappingData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({visible: false, message: ""});
    const [searchForm, setSearchForm] = useState({cmpCd: "", brandCd: "", storeCd: "", restProductCd: "", productNm: "", barcode: "", brandProductCd: ""});

    const defaultColDef = {
        flex: 1,
        resizable: true,
        sortable: true,
        filter: false,
        autoHeaderHeight: true,
        enableRangeSelection: true,
        //rowSelection: 'multiple',
        enableCellTextSelection: false
    };

    const [columnDefs] = useState([
        { field: "cmpCd", hide: true },
        { field: "productCd", hide: true },
        { field: "restProductCd", headerName: "상품코드" },
        { field: "productNm", headerName: "상품명" },
        { field: "sourceCd", headerName: "바코드" },
        { field: "brandProductCd", headerName: "브랜드연결코드"},  // editable: true, cellEditor: 'agTextCellEditor',
        { field: "useYn", hide: true }
    ]);

    const [brandMappingMulticolumn] = useState([
        { field: "no", headerName: "NO", maxWidth: 50,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            showDisabledCheckboxes: true
            //showDisabledCheckboxes: true,
            //rowSelection: 'multiple'
        },
        { field: "cmpCd", hide: true },
        { field: "productCd", hide: true },
        { field: "restProductCd", headerName: "상품코드", hide: true },
        { field: "productNm", headerName: "상품명", hide: true },
        { field: "sourceCd", headerName: "바코드", hide: true },
        { field: "brandProductCd", headerName: "브랜드연결코드", editable: true}
    ]);

    const handleSelect = (code, value) => {
        if (value === "C") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: code, brandCd: "", storeCd: "", cornerCd: ""
            }));
        } else if (value === "B") {
            setSearchForm((state) => ({
                ...state,
                brandCd: code, storeCd: "", cornerCd: ""
            }));
        } else if (value === "S") {
            setSearchForm((state) => ({
                ...state,
                storeCd: code, cornerCd: ""
            }));
        } else if (value === "O") {
            setSearchForm((state) => ({
                ...state,
                cornerCd: code
            }));
        }
    }

    const search = () => {
        props.onError({visible: false, message: ""});

        setBrandMappingData();

        const { cmpCd, brandCd, storeCd } = props.selected;
        //const { cmpCd, brandCd, storeCd } = searchForm;

        if(storeCd.length === 0) {
            alert("점포를 먼저 선택해주세요.");
            return;
        }

        const params = {
            cmpCd: cmpCd,
            brandCd: brandCd,
            storeCd: storeCd,
            restProductCd: searchForm.restProductCd,
            productNm: searchForm.productNm,
            barcode: searchForm.barcode,
            brandProductCd: searchForm.brandProductCd
        };
        console.log(">>> params :: ", params);

        props.onLoading(true);
        getCkProductBrandMultiMappingList(params).then((result) => {
        //getCkProductBrandMappingList(params).then((result) => {
            const { responseBody } = result.data;
            setRowData(responseBody);
        })
        .catch((e) => {
            props.onError({visible: true, message: e.message})
        })
        .finally(() => {
            props.onLoading(false);
        })
    }


    const onCellEditingStopped = (e) => {
        getUpdateRows(e);
    }

    let updateRows = [];

    const getUpdateRows = (e) => {
        const {cmpCd, brandCd, storeCd} = searchForm;
        const colId = e.column.colId;
        console.log("e.newValue :: ", e.newValue);
        if(e.newValue !== ""){
            if (e.oldValue !== e.newValue) {
                const data = {
                    cmpCd: e.data.cmpCd,
                    brandCd: e.data.brandCd,
                    storeCd: e.data.storeCd,
                    productCd: e.data.productCd,
                    restProductCd: e.data.restProductCd,
                    sourceCd: e.data.sourceCd,
                    brandProductCd: e.data.brandProductCd,
                    oldBrandProductCd: e.oldValue,
                    useYn : 'Y'
                }
                updateRows.push(data);
            }
        }

        console.log(">>> update rows :: ", updateRows);
    }
    
    const onRowBrandProductClick = (e) => {
        getBrandProductInfo(e.data);
    }

    const getBrandProductInfo = (data) => {

        const params = {
            cmpCd: data.cmpCd,
            brandCd: data.brandCd,
            storeCd: data.storeCd,
            productCd : data.productCd,
            restProductCd : data.restProductCd,
            instUser : user.userId,
            updUser : user.userId,
            gubun : "dtl"   //Detail
        };
        console.log(">>> params :: ", params);

        props.onLoading(true);
        getCkProductBrandMappingList(params).then((result) => {
            const { responseBody } = result.data;
            setBrandMappingData(responseBody);
        })
        .catch((e) => {
            props.onError({visible: true, message: e.message})
        })
        .finally(() => {
            props.onLoading(false);
        })

    } // End getBrandProductInfo();

    //브랜드 상품코드 추가
    const setNewBrandProductCd = () => {
        const { api } = gridRef.current;
        if (api === null) return;
        const selectRows = api.getSelectedRows();

        console.log("선택한 상품 selectRows :: ", selectRows);

        if(selectRows.length === 0){
            alert("외부 브랜드 상품정보를 먼저 선택해 주세요.");
            return false;
        }

        const newData = {
            cmpCd: selectRows[0].cmpCd,
            brandCd: selectRows[0].brandCd,
            storeCd: selectRows[0].storeCd,
            productCd : selectRows[0].productCd,
            restProductCd : selectRows[0].restProductCd,
            sourceCd : selectRows[0].sourceCd,
            brandProductCd: "",  //최초 행 추가 시 빈값
            useYn: "Y",
            instUser: user.userId,
            updUser: user.userId
        };
        setBrandMappingData((state) => {
            return [...state, newData];
        });

    } //End setNewBrandProductCd()

    //브랜드 상품코드 삭제
    const deleteBrandProduct = (useYn, e) => {
        const selectRows = gridRef.current.api.getSelectedRows();
        const detailSelectRows = detailGridRef.current.api.getSelectedRows();
        console.log("삭제 시 selectRows :: ", selectRows);
        console.log("삭제 시 detailSelectRows :: ", detailSelectRows);

        if(detailSelectRows.length === 0){
            alert("삭제할 행을 선택해주세요.");
            return;
        }
        if (confirm("선택한 브랜드 상품코드를 삭제하시겠습니까?")) {
            deleteProductBrandMapping(detailSelectRows).then((result) => {
                const {responseBody, responseCode, responseMessage} = result.data;
                if (responseCode === "200") {
                    alert("처리되었습니다.");
                    search();
                    getBrandProductInfo(selectRows[0]);
                }
            });
        }
    } //deleteBrandProduct

    //브랜드 상품코드 등록 및 수정
    const saveBrandProduct = (useYn, e) => {
        const selectRows = gridRef.current.api.getSelectedRows();
        console.log("저장 시 selectRows :: ", selectRows);

        detailGridRef.current.api.stopEditing();

        // 딜레이를 주자
        setTimeout(() => {

            if(updateRows.length === 0){
                alert("변경된 데이터가 없습니다.");
                return;
            }
            let pushData = updateRows;
            updateRows = [];
            console.log("실제 저장할 pushData :: ", pushData);

            updateProductBrandMapping(pushData).then((result) => {
                const {responseBody, responseCode, responseMessage} = result.data;
                if (responseCode === "200") {
                    alert("처리되었습니다.");
                    search();
                    getBrandProductInfo(selectRows[0]);
                } else { //저장 실패 시!
                    alert("등록하신 브랜드연결코드가 다른 상품(코드)에 매핑되어 있습니다.\n기존 매핑 정보 삭제 후 다시 저장해주세요.");
                }
            })
        }, 200);
    } //End saveBrandProduct()


    return (
        <>
            <StoreCornerListWhere type={"S"} account={props.account} selected={searchForm} onSelect={(c, v) => handleSelect(c, v)}/>
            <CForm className="row row-cols-lg-auto p-1 g-1">
                <CCol xs={12}>
                    <CInputGroup className={"mb-1"} size={"sm"}>
                        <CInputGroupText style={{width: 100}}>상품코드</CInputGroupText>
                        <CFormInput id="productCd"
                                    onChange={(e) => {
                                        setSearchForm((state) => ({
                                            ...state,
                                            restProductCd: e.target.value
                                        }));
                                    }}/>
                    </CInputGroup>
                </CCol>
                <CCol xs={12}>
                    <CInputGroup className={"mb-1"} size={"sm"}>
                        <CInputGroupText style={{width: 100}}>상품명</CInputGroupText>
                        <CFormInput id="productNm"
                                    onChange={(e) => {
                                        setSearchForm((state) => ({
                                            ...state,
                                            productNm: e.target.value
                                        }));
                                    }}
                        />
                    </CInputGroup>
                </CCol>
                <CCol xs={12}>
                    <CInputGroup className={"mb-1"} size={"sm"}>
                        <CInputGroupText style={{width: 100}}>바코드</CInputGroupText>
                        <CFormInput id="barcode"
                                    onChange={(e) => {
                                        setSearchForm((state) => ({
                                            ...state,
                                            barcode: e.target.value
                                        }));
                                    }}/>
                    </CInputGroup>
                </CCol>
                <CCol xs={12}>
                    <CInputGroup className={"mb-1"} size={"sm"}>
                        <CInputGroupText style={{width: 120}}>브랜드연결코드</CInputGroupText>
                        <CFormInput id="barcode"
                                    onChange={(e) => {
                                        setSearchForm((state) => ({
                                            ...state,
                                            brandProductCd: e.target.value
                                        }));
                                    }}/>
                    </CInputGroup>
                </CCol>
                <div className="d-grid gap-1 d-md-flex justify-content-md-end align-items-center">
                    <CButton size={"sm"} color="dark" onClick={search}>조회</CButton>
                </div>
            </CForm>

            <CRow>
             <CCol xs={8}>
                 <div className="d-grid gap-1 d-md-flex " style={{ marginTop: 15 }}>
                     <h5>외부 브랜드 상품코드 매핑 목록</h5>
                 </div>
                <div className="ag-theme-alpine" style={{ width: "100%", height: 500, marginTop: 10 }}>
                    <AgGridReact
                        ref={gridRef}
                        rowData={rowData}
                        rowSelection={"single"}
                        animateRows={true}
                        pagination={true}
                        singleClickEdit={true}
                        enableRangeSelection={true}
                        enableCellTextSelection={true}
                        suppressClipboardPaste={true}
                        onRowClicked={onRowBrandProductClick}
                        localeText={{noRowsToShow: "조회 결과가 없습니다."}}
                        defaultColDef={defaultColDef}
                        columnDefs={columnDefs}>

                    </AgGridReact>
                </div>
             </CCol>

            <CCol xs={4}>
                <div className="d-grid gap-1 d-md-flex " style={{ marginTop: 15 }}>
                    <h5>브랜드 상품추가 등록/삭제</h5>
                    <span style={{marginLeft: 15}}>
                    <CButton size={"sm"} color="primary" onClick={setNewBrandProductCd} style={{marginRight: 5}}>추가</CButton>
                    <CButton size={"sm"} color="primary" onClick={(e)=>{saveBrandProduct("Y", e)}} style={{ marginRight: 5 }}>저장</CButton>
                    <CButton size={"sm"} color="primary" onClick={(e)=>{deleteBrandProduct("N", e)}} tyle={{ marginRight: 5 }}>삭제</CButton>
                    </span>
                </div>

                <div className="ag-theme-alpine" style={{ width: "100%", height: 500, marginTop: 10 }}>
                    <AgGridReact
                        ref={detailGridRef}
                        rowData={brandMappingData}
                        rowSelection={"multiple"}
                        animateRows={true}
                        pagination={true}
                        singleClickEdit={true}
                        enableRangeSelection={true}
                        enableCellTextSelection={true}
                        suppressClipboardPaste={true}
                        onCellEditingStopped={onCellEditingStopped}
                        localeText={{noRowsToShow: "조회 결과가 없습니다."}}
                        defaultColDef={defaultColDef}
                        columnDefs={brandMappingMulticolumn}>
                    </AgGridReact>
                </div>
            </CCol>
        </CRow>
        </>
    );
}

const mapStateToProps = (state) => {
    const { account, store, selected } = state;
    return {
        account, store, selected
    };
};

export default connect(mapStateToProps, null)(ProductBrandMultiMapping);
